import React, { ReactElement } from 'react'
import Image from 'next/image'
import src from '../../../../../public/splashPage/avatars/max.webp'

export const MaxImage: React.FC<unknown> = (): ReactElement => (
    <Image src={src} alt={'Max'} />
)
